import { Box, Checkbox, Divider, FormControl, Grid, TextField, Typography } from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from '@material-ui/icons/Edit';
import { TranslationPrefixes } from "consts/translationPrefixes";
import useToggleSelect from "hooks/useToggleSelect";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { getColumns } from "../../common/Utils/ActionUtils";
import { RoutesUrl } from "../../common/consts/Routes";
import { deleteItem, getData } from "../../services/service";
import { TableComponentToPrint } from "../ComponentToPrint/TableComponent";
import AlertModal from "../shared/AlertModal";
import CardComponent from "../shared/CardComponent";
import { CardHeaderActions } from "../shared/CardHeaderActions";
import TableComponent, { Column } from "../shared/TableComponent";
const formatData = (data: any[]) => {
    return data.map(el => {
        Object.keys(el).forEach(key => {
            if (typeof el[key] === 'boolean') {
                if (el[key] == true) {
                    el[key] = "Да"
                } else {
                    el[key] = "Не"
                }
            }
            if (key === "dynamicRows") {

                let i = 0;
                let finalString = "";
                for (const person of el[key]) {
                    if (person) {
                        let str = "";
                        if (person?.name?.length > 0) {
                            str += "Име: " + person.name;
                        }
                        if (person?.position?.length > 0) {
                            str += "<br/> Длъжност: " + person.position;
                        }
                        if (person?.phone?.length > 0) {
                            str += "<br/> Тел.: " + person.phone;
                        }
                        if (person?.email?.length > 0) {
                            str += "<br/> Имейл: " + person.email + "";
                        }
                        if (str.length > 0) {
                            i++;
                            finalString += i + "." + str + '<br/><br/>';
                        }
                    }
                }
                finalString = finalString.slice(0, -10)
                el[key] = finalString;
            }

        });
        return el;
    })
}

const getCsvData = (data: any[]) => {
    return data.map(el => {
        Object.keys(el).forEach(key => {
            if (typeof el?.key === "string") {
                el[key] = el[key].split("<br/>").join('\n');
            }
        });
        return el;
    })
}

function List() {
    const { t } = useTranslation();
    const { adsFields, actions } = TranslationPrefixes;

    const [data, setData] = useState<Array<any>>([]);
    const [selected, setSelected] = useState<any | null>(null);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [openedModal, setOpenedModal] = useState<boolean>(false);
    const [currentSearch, setCurrentSearch] = useState<string>("");


    const { allSelectedIds, toggleSelect } = useToggleSelect({ identificatorSelectors: data.map(el => el.id) })

    const selectedData = data.filter(el => allSelectedIds.includes(el.id));



    const handleDelete = (dataBases: any) => {
        setSelected(dataBases);
        setOpenedModal(true);
    }

    const handleModalSuccess = async () => {
        if (!selected || !selected.id) return;
        const { id } = selected;
        try {
            await deleteItem("clients", id);
            toast.success('Успешно изтриване!');
            const newData = data.filter((proc) => proc.id !== id);
            setData(newData);
        } catch (e) {
            toast.error(`${t(`${actions}errorDelete`)} ${selected.name}`);
        }

        setSelected(null);
        setOpenedModal(false);
    }

    const closeModal = () => {
        setSelected(null);
        setOpenedModal(false);
    }

    useEffect(() => {
        setIsLoading(true);
        getData("clients").then((values) => {
            setData(formatData(values));
        }).finally(() => setIsLoading(false));
    }, [])


    const columns: Array<Column> = [
        {
            cell: (el) => {
                return (
                    <Checkbox
                        checked={allSelectedIds.includes(el.id)}
                        onChange={() => toggleSelect({ singleSelector: el.id })}
                    />
                )
            },
            header: "checkBox"
        },
        {
            accessor: "name",
            cell: (val) => {
                return (
                    <Typography variant="body1">{val}</Typography>
                )
            },
            header: "Име"
        },

        {
            accessor: "eik",
            cell: (val) => {
                return (
                    <Typography variant="body1" title={val}>{val}</Typography>
                )
            },
            header: "ЕИК"
        },
        {
            accessor: "dds",
            cell: (val: string | undefined) => {
                return (
                    <Typography variant="body1" title={val}>{val}</Typography>
                );
            },
            header: "Регистрация по ДДС"
        },
        {
            accessor: "services",
            cell: (val: string) => {
                return (
                    <Typography variant="body1" title={val}>{val}</Typography>
                )
            },
            header: "Услуги"
        },
        {
            accessor: "country",
            cell: (val: string) => {
                return (
                    <Typography variant="body1" title={val}>{val}</Typography>
                )
            },
            header: "Държава"
        },
        {
            accessor: "address",
            cell: (val: string) => {
                return (
                    <Typography variant="body1" title={val}>{val}</Typography>
                )
            },
            header: "Адрес"
        },
        {
            accessor: "dynamicRows",
            cell: (val: string) => {
                return (
                    <Typography variant="body1">
                        <span dangerouslySetInnerHTML={{ __html: val || "" }}></span>
                    </Typography>
                )
            },
            header: "Лицa за контакт"
        },
        {
            accessor: "site",
            cell: (val: string) => {
                return (
                    <Typography variant="body1" title={val}>{val}</Typography>
                )
            },
            header: "Сайт"
        },
        {
            accessor: "others",
            cell: (val: string) => {
                return (
                    <Typography variant="body1" title={val}>{val}</Typography>
                )
            },
            header: "Други"
        },
        {
            cell: (dataBases) => {
                return (
                    <Box display="flex">
                        <Link to={`${RoutesUrl.clients.edit(dataBases.id)}`}>
                            <Typography color="primary" title={t(`${actions}edit`)}><EditIcon /></Typography>
                        </Link>
                        <Typography color="primary" title={t(`${actions}delete`)} onClick={() => handleDelete(dataBases)} style={{ cursor: "pointer" }}>
                            <DeleteIcon />
                        </Typography>
                    </Box>
                )
            },
            header: t(`${actions}action`)
        },
    ];

    let componentRef = useRef<TableComponentToPrint | null>(null);

    const csvColumns = [
        {
            name: "Име",
            value: "name"
        },
        {
            name: "ЕИК",
            value: "eik"
        },
        {
            name: "Регистрация по ДДС",
            value: "dds"
        },
        {
            name: "Услуги",
            value: "services"
        },
        {
            name: "Държава",
            value: "country"
        },
        {
            name: "Адрес",
            value: "address"
        },
        {
            name: "Адрес",
            value: "address"
        },
        {
            name: "Сайт",
            value: "site"
        },
        {
            name: "Лицa за контакт",
            value: "dynamicRows"
        }
    ];


    const renderHeaderActions = () => {
        if (!selectedData.length) return;
        const csvData = getCsvData(selectedData);
        const csvFileName = `Ads_${+new Date()}.csv`;
        return (
            <CardHeaderActions
                csvHeaders={getColumns(csvColumns)}
                csvFileName={csvFileName}
                csvData={csvData}
                componentRef={componentRef}
            />
        );
    }

    return (
        <CardComponent title={'Clients Hub'} isLoading={isLoading} headerActions={renderHeaderActions()}>
            <Box>
                <AlertModal onClose={closeModal} onSuccess={handleModalSuccess} show={openedModal} title={t(`${actions}delete`)} >
                    <Typography>{t(`${actions}questionDeleteOf`)} {selected ? selected.title : ""} ?</Typography>
                </AlertModal>
                <Grid container style={{ flexGrow: 1 }} spacing={2} alignItems="center">
                    <Grid item xs={12}>
                        <FormControl style={{ width: "100%" }}>
                            <TextField
                                fullWidth
                                onChange={(e) => {
                                    setCurrentSearch(e.target.value as string);
                                }}
                                label={t(`${actions}search`)}
                            />
                        </FormControl>
                    </Grid>
                </Grid>
                {
                    data.length > 0 && (
                        <div
                            style={{ display: "none" }}
                        >
                            <TableComponentToPrint
                                ref={componentRef}
                                data={selectedData}
                                headers={csvColumns}
                                title={t(`${adsFields}list`)}

                            />
                        </div>
                    )
                }
                <Box marginBottom="15px" marginTop="15px">
                    <Divider />
                </Box>
                <TableComponent
                    data={data}
                    currentSearch={currentSearch}
                    searchKeys={["name"]}
                    columns={columns}
                    checkBox={{
                        checked: data.length === allSelectedIds.length,
                        onChangeCheckBox: (toggleAll) => {
                            toggleSelect({ toggle: toggleAll })
                        }
                    }}
                />
            </Box>
        </CardComponent>
    )
}

export default List;
